import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { Link } from "react-router-dom";
import { PATHS } from "constants/pathConstants";
import { COLORS } from "components/v3/Theme/colors";
import {
  getNoticeAlertContainerSx,
  noticeAlertIconSx
} from "components/v3/sharedComponents/noticeAlertStyles";

const MembershipExpiredBanner: React.FC = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        ...getNoticeAlertContainerSx(COLORS.NOTICE),
        alignSelf: isDesktop ? "center" : "stretch"
      }}
      role="alert"
    >
      <WarningAmberRoundedIcon sx={noticeAlertIconSx} aria-hidden />
      <Typography
        component="span"
        variant="body_strong"
        sx={{ color: COLORS.WHITE }}
      >
        Your membership has expired. Click{" "}
        <Link
          to={PATHS.ACCOUNT_MANAGEMENT_PAYMENT_INFORMATION}
          style={{
            color: COLORS.WHITE,
            textDecoration: "underline",
            fontWeight: 600
          }}
        >
          here
        </Link>{" "}
        to renew.
      </Typography>
    </Box>
  );
};

export default MembershipExpiredBanner;
